import Vue from "vue";

export function pageSysLogApi(params, success,complete) {
    let url = "/admin/web/sysLog/pageSysLog";
    Vue.prototype.alexPost(url, params, success,null,complete);
}


